import axios from 'axios'
import AppStore from '../AppStore'
import { ReferralBaseProduct, ReferralCampaign } from '../types'
import { responseErrorCheck } from './UtilsApi'

export default class ReferralCampaignApi {
  static endpoint() {
    return AppStore.apiUrl + '/admin/discount-campaigns'
  }

  static getBaseProducts(): Promise<ReferralBaseProduct[]> {
    return axios
      .get(`${ReferralCampaignApi.endpoint()}/base-products`)
      .then(responseErrorCheck)
      .catch(responseErrorCheck)
  }

  static getCampaigns(): Promise<ReferralCampaign[]> {
    return axios.get(ReferralCampaignApi.endpoint()).then(responseErrorCheck).catch(responseErrorCheck)
  }

  static getCampaign(campaignKey: string): Promise<ReferralCampaign> {
    return axios
      .get(`${ReferralCampaignApi.endpoint()}/${campaignKey}`)
      .then(responseErrorCheck)
      .catch(responseErrorCheck)
  }

  static createCampaign(campaign: ReferralCampaign): Promise<ReferralCampaign> {
    return axios.post(ReferralCampaignApi.endpoint(), campaign).then(responseErrorCheck).catch(responseErrorCheck)
  }

  static updateCampaign(campaignKey: string, campaign: ReferralCampaign): Promise<ReferralCampaign> {
    return axios
      .put(`${ReferralCampaignApi.endpoint()}/${campaignKey}`, campaign)
      .then(responseErrorCheck)
      .catch(responseErrorCheck)
  }
}
